import { lazy } from 'react';
import { createLiveQueryProvider } from './createLiveQueryProvider.js';
const GroqStoreProvider = lazy(() => import('../GroqStoreProvider/index.js'));
const LiveStoreProvider = lazy(() => import('../LiveStoreProvider/index.js'));
const LiveQueryProvider = createLiveQueryProvider({
  GroqStoreProvider,
  LiveStoreProvider
});
export { LiveQueryProvider, createLiveQueryProvider };
//# sourceMappingURL=index.js.map
